// Card 17trt6jbffe: a tela Mensagens avisa o menu para atualizar o badge de
// nao lidas do suporte (depois de ler ou responder).
export const MESSAGES_UNREAD_REFRESH_EVENT = "pitch:refresh-support-unread";

export function dispatchSupportUnreadRefresh() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(MESSAGES_UNREAD_REFRESH_EVENT));
}
